import "./budgetListTotals.css";

export const BudgetListTotals = ({ totals, loading, error }) => (
  <section
    className="p-budget-list-totals"
    aria-label="Totales de presupuestos"
    aria-live="polite"
    aria-busy={loading}
  >
    <div>
      <h2>Total neto de presupuestos en soles</h2>
      <p>
        Todos los resultados de los filtros actuales, no solo esta página. Sin
        impuestos.
      </p>
    </div>
    {loading ? (
      <p>Calculando totales…</p>
    ) : error ? (
      <p role="alert">
        No se pudieron cargar los totales. Vuelve a consultar la lista.
      </p>
    ) : (
      totals && (
        <>
          <span className="p-budget-list-count">
            {totals.count} {totals.count === 1 ? "presupuesto" : "presupuestos"}
          </span>
          <div className="p-budget-list-amounts">
            <div>
              <strong>
                S/{" "}
                {new Intl.NumberFormat("es-PE", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }).format(Number(totals.amount))}
              </strong>
            </div>
          </div>
          <p>
            Dólares convertidos al tipo de cambio de cada presupuesto. Sin tipo
            de cambio válido: S/ 3,40 por dólar.
          </p>
          {totals.default_exchange_rate_count > 0 && (
            <p>
              {totals.default_exchange_rate_count} presupuestos usan el tipo de
              cambio predeterminado.
            </p>
          )}
          {totals.count === 0 && <p>No hay presupuestos con estos filtros.</p>}
        </>
      )
    )}
  </section>
);
